// src/main.jsx

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.jsx";
import IntlProviderWrapper from "./i18n/IntlProviderWrapper";

import "./styles/global.css";
import "./styles/dashboard.css";
import "./styles/chatbot.css";
import "./styles/la-foundation.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <IntlProviderWrapper>
        <App />
      </IntlProviderWrapper>
    </BrowserRouter>
  </React.StrictMode>
);
